import { action, observable } from 'mobx'
import { validationContext, func } from 'validx'
import { vif } from 'utils/validx-validators'

export const AVAILABLE_AGENT_ACTIONS = [
  ['MISSING_DOCUMENTS', 'Missing Documents'],
  ['RM_INTRO', 'RM Intro'],
  ['PRO_REACHOUT', 'Pro Reachout'],
  ['TAX_ORGANIZER_QUESTIONS', 'Tax Organizer Questions'],
  ['CLIENT_OUTREACH', 'Client Outreach'],
  ['CLIENT_ASSISTANCE_REQUEST', 'Client Assistance Request'],
  ['DRAFT_APPROVAL', 'Draft Approval Outreach'],
]

export default class AgentsConfigViewModel {
  @observable enabled = false
  @observable automatedActionsEnabled = false
  @observable actions = []
  @observable rmIntroChatMessage = ''
  @observable rmShowPhoneNumber = false
  @observable paperFiling = false

  validation = validationContext(this, {
    actions: [
      vif(() => this.automatedActionsEnabled, [
        func(
          (opts) => opts.value && opts.value.length > 0,
          'At least one action must be selected'
        ),
      ]),
    ],
  })

  @action
  activate(agentsConfig) {
    this.enabled = agentsConfig?.enabled || false
    this.automatedActionsEnabled =
      agentsConfig?.automated_actions_enabled || false
    this.actions = agentsConfig?.actions || []
    this.rmIntroChatMessage = agentsConfig?.rm_intro_chat_message || ''
    this.rmShowPhoneNumber = agentsConfig?.rm_show_phone_number || false
    this.paperFiling = agentsConfig?.paper_filing || false
  }

  toJSON() {
    return {
      enabled: this.enabled,
      automated_actions_enabled: this.automatedActionsEnabled,
      actions: this.actions,
      rm_intro_chat_message: this.rmIntroChatMessage,
      rm_show_phone_number: this.rmShowPhoneNumber,
      paper_filing: this.paperFiling,
    }
  }
}
